import React, { useState, useEffect, useContext } from 'react';
import {
	Select,
	MenuItem,
	FormControl,
	InputLabel,
	Button,
	Stack,
	TextField,
	Box
} from '@mui/material';
import { DataContext } from '../../../../context/DataContext';
import { getToken } from '../../../../api/Account';
import { getSucursalByUserAsync } from '../../../../api/Users';
import { getUsuariosCampoAsync } from '../../../../api/Positions';
import { getRuta, simpleMessage } from '../../../../helpers/Helpers';
import { faMapLocationDot } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import moment from 'moment/moment';
import { accionPrincipalSx } from '../../../../components/ui/accionPrincipal';

const SelectorRutaGestor = () => {
	const [gestorList, setGestorList] = useState([]);
	const [selectedGestor, setSelectedGestor] = useState('');
	const [selectedFecha, setSelectedFecha] = useState(new Date());

	const [sucursalList, setSucursalList] = useState([]);
	const [selectedSucursal, setSelectedSucursal] = useState('t');

	const { setIsLoading, setIsUnautorized } = useContext(DataContext);
	let ruta = getRuta();
	const token = getToken();

	useEffect(() => {
		getGestores(selectedSucursal);
		getSucursals();
	}, []);

	const verReport = () => {
		// Se consulta un solo gestor y un solo dia: una jornada deja cientos de puntos y
		// varios dias juntos harian el mapa ilegible.
		if (selectedGestor === '') {
			simpleMessage('Seleccione una persona', 'error');
			return;
		}
		if (!moment(selectedFecha).isValid()) {
			simpleMessage('Seleccione una fecha válida', 'error');
			return;
		}

		var params = `${selectedGestor}/${moment(selectedFecha).format('YYYY-MM-DD')}`;
		window.open(`${ruta}/r-rutagestor/${params}`);
	};

	const getSucursals = async () => {
		setIsLoading(true);
		const result = await getSucursalByUserAsync(token);
		if (!result.statusResponse) {
			setIsLoading(false);
			if (result.error === 'Unauthorized') {
				setIsUnautorized(true);
				return;
			}
			simpleMessage(result.error, 'error');
			return;
		}
		setIsLoading(false);
		setSucursalList(result.data.result);
	};

	const onChangeSucursal = (value) => {
		setSelectedSucursal(value);
		setSelectedGestor('');
		getGestores(value);
	};

	const getGestores = async (sucursal) => {
		setIsLoading(true);
		// Sin sucursal indicada el backend toma todas las del usuario.
		const result = await getUsuariosCampoAsync(token, sucursal === 't' ? null : sucursal);
		if (!result.statusResponse) {
			setIsLoading(false);
			if (result.error === 'Unauthorized') {
				setIsUnautorized(true);
				return;
			}
			simpleMessage(result.error, 'error');
			return;
		}

		setIsLoading(false);
		setGestorList(result.data.result);
	};

	return (
		<div>
			<Box sx={{ width: '100%', maxWidth: 550 }}>
				<Stack spacing={2}>
					<FormControl fullWidth style={{ textAlign: 'left' }}>
						<InputLabel id="demo-simple-select-standard-label">Sucursal</InputLabel>
						<Select
							labelId="demo-simple-select-standard-label"
							id="demo-simple-select-standard"
							onChange={(e) => onChangeSucursal(e.target.value)}
							value={selectedSucursal}
							label="Sucursal"
						>
							{sucursalList.map((item) => {
								return (
									<MenuItem key={item.id} value={item.id}>
										{item.description}
									</MenuItem>
								);
							})}
							<MenuItem key={'t'} value={'t'}>
								TODAS...
							</MenuItem>
						</Select>
					</FormControl>

					<FormControl fullWidth style={{ textAlign: 'left', marginTop: 20 }}>
						<InputLabel id="demo-simple-select-standard-label">Personal</InputLabel>
						<Select
							labelId="demo-simple-select-standard-label"
							id="demo-simple-select-standard"
							onChange={(e) => setSelectedGestor(e.target.value)}
							value={selectedGestor}
							label="Personal"
							style={{ textAlign: 'left' }}
						>
							<MenuItem value="">
								<em>Seleccione una persona</em>
							</MenuItem>
							{/* Conviven gestores, desembolsadores y promotores: el rol va al lado
							del nombre porque es lo que dice qué se espera de ese recorrido. */}
							{gestorList.map((item) => {
								return (
									<MenuItem key={item.id} value={item.id}>
										{item.rolName ? `${item.fullName} · ${item.rolName}` : item.fullName}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>

					<DesktopDatePicker
						closeOnSelect
						label="Seleccione una fecha"
						inputFormat="DD/MM/YYYY"
						value={selectedFecha}
						onChange={(newValue) => setSelectedFecha(newValue)}
						renderInput={(params) => <TextField {...params} />}
					/>

					<Button
						variant="contained"
						startIcon={<FontAwesomeIcon icon={faMapLocationDot} />}
						onClick={() => verReport()}
						sx={accionPrincipalSx}
					>
						Ver Recorrido
					</Button>
				</Stack>
			</Box>
		</div>
	);
};

export default SelectorRutaGestor;
